import { render, staticRenderFns } from "./BCXMessengerInputResizer.vue?vue&type=template&id=7c4f6aad&scoped=true"
import script from "./BCXMessengerInputResizer.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerInputResizer.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerInputResizer.vue?vue&type=style&index=0&id=7c4f6aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4f6aad",
  null
  
)

export default component.exports